










































































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BaseSheet } from "../../modules/teacher/BaseSheetEdit"

export interface Data {
  base_sheet_id: string
  baseSheet: BaseSheet | null
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const state = reactive<Data>({
      base_sheet_id: null,
      baseSheet: null,
      errors: []
    });

    const update = async () => {

      if(!window.confirm("試験情報を更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");
      
      await http.patch(`/api/base_sheet_edit/${state.base_sheet_id}`, {base_sheet: state.baseSheet}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.base_sheet_id = context.root.$route.params.base_sheet_id;
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/base_sheet_edit?base_sheet_id=${state.base_sheet_id}`).then(response => {
        state.baseSheet = new BaseSheet(response.data.base_sheet);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      update,
    }
  },
})
